export default __webpack_public_path__ + "static/media/Brow_7_C3.cc473df3.svg";